var play_icon_default = {
  "shadow": "B8-e-",
  "playIcon": "W6-xY"
};
export {
  play_icon_default as default
};
//# sourceMappingURL=play-icon-scss.js.map
